import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { vehicleTypeDetailsFormData } from "./vehicleAllFields";
import FormField from "../../../components/common/FormField";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getSingleVehicleTypeDetails,
  setUpdateVehicleTypeResponse,
} from "../../../store/reducers/vehicleSlice";
import editIcon from "../../../assets/images/actionIcon/edit.png";
import deleteIcon from "../../../assets/images/actionIcon/delete.png";
interface VehicleTypeDetailsProps {
  selectedId: string | any; // Adjust type as needed
  onEditClick?: () => void;
  onDeleteClick?: () => void;
}

const VehicleTypeDetails: React.FC<VehicleTypeDetailsProps> = ({
  selectedId,
  onEditClick,
  onDeleteClick,
}) => {
  const { singleVehicleType, isAddVehicleTypeResponse } = useSelector(
    (state: any) => state.vehicle,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedId) {
      dispatch(getSingleVehicleTypeDetails(selectedId));
      dispatch(setUpdateVehicleTypeResponse(false));
    }
  }, [dispatch, selectedId, isAddVehicleTypeResponse]);

  return (
    <>
      <Grid
        container
        sx={{
          width: "100% !important",
          marginTop: "10px",
          padding: "10px !important",
          border: "1px solid #C4CDD5",
          borderRadius: "5px",
          overflow: "hidden",
          background: "#E5F4F1",
          position: "relative",
        }}
      >
        {singleVehicleType?.is_deletable && (
          <img
            src={deleteIcon}
            onClick={onDeleteClick}
            style={{
              width: "24px",
              height: "24px",
              position: "absolute",
              right: "40px",
              cursor: "pointer",
            }}
            alt="edit"
          />
        )}
        <img
          src={editIcon}
          onClick={onEditClick}
          style={{
            width: "24px",
            height: "24px",
            position: "absolute",
            right: "10px",
            cursor: "pointer",
          }}
          alt="delete"
        />
        {vehicleTypeDetailsFormData.map((field, index) => (
          <FormField
            key={`${field.id}-${index}`}
            onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
              e.preventDefault()
            }
            {...{
              ...field,
              value: singleVehicleType ? singleVehicleType[field.id] : "",
              // Conditional options for county based on country
              disabled: true,

              variant: "outlined", // Adding this variant prop
              isNonMarginTop: true,
              InputProps: {
                sx:
                  field.type === "text" || field.type === "password"
                    ? { height: "36px" }
                    : {
                        padding: "6px 12px",
                        // height: "36px",
                      },
              },
            }}
          />
        ))}
      </Grid>
    </>
  );
};

export default VehicleTypeDetails;
